import _ from 'lodash';

window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// import axios from 'axios';
// window.axios = axios;
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// window.axios.defaults.withCredentials = true;

/**
 * Import userflow and make it available globally
 */
import userflow from 'userflow.js';
window.userflow = userflow;

import '../../vendor/wire-elements/pro/resources/js/overlay-component.js';
import '../../vendor/wire-elements/pro/resources/js/spotlight-component.js';
import './echo';
